import React from 'react'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../../common/RequiredInputs'

const SelectCategory = (
    {
        categories,
        inputs, 
        handleChange,

    }) => {
    return (
        <Form.Group size="lg">
            <Form.Label className="form__labels"> Categoría <RequieredInputs/> </Form.Label>
            <Form.Control
                as="select"
                className="user-input form__input"
                type="text"
                name="id_TipoCategoria"
                value={inputs.id_TipoCategoria}
                onChange={handleChange}
            >
                <option hidden>Categoría principal</option>
                {
                    categories ? categories.map((category, i) =>
                        <option
                            key={i}
                            value={category.id_TipoCategoria}>
                            {category.nombre}
                        </option>
                    ) : null
                }
            </Form.Control>
        </Form.Group>

    )
}

export default SelectCategory